// Bundle Collapse/Expand Functionality
document.addEventListener('DOMContentLoaded', function() {
    
    // Get all bundle containers and radio inputs
    const bundleContainers = document.querySelectorAll('.pd-main-container');
    const bundleRadios = document.querySelectorAll('.bundle-radio');
    const bundleLabels = document.querySelectorAll('.bundle-label');
    
    // Function to collapse all bundle options
    function collapseAllBundles() {
        bundleContainers.forEach(container => {
            const collapsibleContent = container.querySelector('.pd-collapsible-content');
            if (collapsibleContent) {
                container.classList.remove('expanded');
                collapsibleContent.style.height = '0px';
            }
        });
    }
    
    // Function to expand a specific bundle
    function expandBundle(container) {
        const collapsibleContent = container.querySelector('.pd-collapsible-content');
        if (collapsibleContent) {
            container.classList.add('expanded');
            
            // Calculate the natural height of the content
            const content = collapsibleContent.querySelector('.pd-includes-section');
            if (content) {
                const contentHeight = content.scrollHeight;
                collapsibleContent.style.height = contentHeight + 'px';
            }
        }
    }
    
    // Function to update bundle selection
    function updateBundleSelection(selectedRadio) {
        console.log('Bundle selection updating:', selectedRadio);
        
        const selectedContainer = selectedRadio.closest('.pd-main-container');
        const bundleQty = selectedRadio.dataset.bundleQty;
        const bundlePrice = selectedRadio.dataset.bundlePrice;
        const discount = selectedRadio.dataset.discount;
        const productType = selectedRadio.dataset.productType;
        
        console.log('Bundle data:', { bundleQty, bundlePrice, discount });
        
        // Update hidden form fields
        const bundleTitleMap = {
            '1': `1x ${document.querySelector('[data-bundle-qty="1"]').closest('.pd-main-container').querySelector('.pd-product-title').textContent}`,
            '2': document.querySelector('[data-bundle-qty="2"]').closest('.pd-main-container').querySelector('.pd-product-title').textContent,
            '3': document.querySelector('[data-bundle-qty="3"]').closest('.pd-main-container').querySelector('.pd-product-title').textContent
        };
        
        // Update hidden inputs
        const selectedBundleInput = document.getElementById('selected-bundle-property');
        const discountAppliedInput = document.getElementById('discount-applied-property');
        const bundlePriceInput = document.getElementById('bundle-price-property');
        
        if (selectedBundleInput) {
            selectedBundleInput.value = bundleTitleMap[bundleQty] || `${bundleQty}x Product`;
        }
        
        if (discountAppliedInput) {
            const discountPercent = Math.round(parseFloat(discount) * 100);
            discountAppliedInput.value = `${discountPercent}%`;
        }
        
        if (bundlePriceInput) {
            bundlePriceInput.value = selectedRadio.closest('.pd-main-container').querySelector('.pd-current-price').textContent;
        }
        
        // Update quantity input if it exists
        const quantityInput = document.querySelector('input[name="quantity"]');
        if (quantityInput) {
            quantityInput.value = bundleQty;
        }
        
        // Collapse all first, then expand selected
        collapseAllBundles();
        
        // Small delay to allow collapse animation to start
        setTimeout(() => {
            expandBundle(selectedContainer);
        }, 50);
    }
    
    // Add click event listeners to labels (since they wrap the entire clickable area)
    bundleLabels.forEach(label => {
        label.addEventListener('click', function(e) {
            // Prevent double-firing if clicking directly on radio
            if (e.target.type === 'radio') return;
            
            console.log('Label clicked');
            
            const radio = this.querySelector('.bundle-radio');
            if (radio) {
                radio.checked = true;
                updateBundleSelection(radio);
                
                // Trigger change event for any other listeners
                radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    });
    
    // Add change event listeners to radio buttons
    bundleRadios.forEach(radio => {
        radio.addEventListener('change', function() {
            console.log('Radio change event:', this.checked);
            if (this.checked) {
                updateBundleSelection(this);
            }
        });
    });
    
    // Initialize: expand the first (default) option
    const defaultRadio = document.querySelector('.bundle-radio[checked]') || document.querySelector('.bundle-radio');
    if (defaultRadio) {
        console.log('Initializing with default radio');
        updateBundleSelection(defaultRadio);
    }
    
    // Handle responsive behavior
    function handleResponsive() {
        const isMobile = window.innerWidth <= 767;
        
        bundleContainers.forEach(container => {
            if (container.classList.contains('expanded')) {
                const collapsibleContent = container.querySelector('.pd-collapsible-content');
                if (collapsibleContent) {
                    const content = collapsibleContent.querySelector('.pd-includes-section');
                    if (content) {
                        // Recalculate height for responsive changes
                        collapsibleContent.style.height = 'auto';
                        const newHeight = content.scrollHeight;
                        collapsibleContent.style.height = newHeight + 'px';
                    }
                }
            }
        });
    }
    
    // Add resize listener for responsive behavior
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(handleResponsive, 250);
    });
    
    // Additional functionality for smooth animations
    bundleContainers.forEach(container => {
        const collapsibleContent = container.querySelector('.pd-collapsible-content');
        if (collapsibleContent) {
            // Ensure smooth transitions
            collapsibleContent.style.transition = 'height 0.4s ease';
            collapsibleContent.style.overflow = 'hidden';
        }
    });
    
    window.debugBundle = function() {
        console.log('Bundle containers:', bundleContainers.length);
        console.log('Bundle radios:', bundleRadios.length);
        console.log('Bundle labels:', bundleLabels.length);
        
        const bundleSection = document.querySelector('.bundle-section');
        console.log('Bundle section exists:', !!bundleSection);
        
        bundleRadios.forEach((radio, index) => {
            console.log(`Radio ${index}:`, {
                checked: radio.checked,
                value: radio.value,
                bundleQty: radio.dataset.bundleQty,
                bundlePrice: radio.dataset.bundlePrice,
                discount: radio.dataset.discount
            });
        });
    };
  
});

// Additional utility functions for external integration
window.BundleManager = {
    // Programmatically select a bundle option
    selectBundle: function(bundleNumber) {
        const radio = document.querySelector(`.bundle-radio[data-bundle-qty="${bundleNumber}"]`);
        if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
        }
        return false;
    },
    
    // Get currently selected bundle info
    getSelectedBundle: function() {
        const selectedRadio = document.querySelector('.bundle-radio:checked');
        if (selectedRadio) {
            return {
                qty: selectedRadio.dataset.bundleQty,
                price: selectedRadio.dataset.bundlePrice,
                discount: selectedRadio.dataset.discount,
                value: selectedRadio.value
            };
        }
        return null;
    },
    
    // Force collapse all bundles
    collapseAll: function() {
        document.querySelectorAll('.pd-main-container').forEach(container => {
            const collapsibleContent = container.querySelector('.pd-collapsible-content');
            if (collapsibleContent) {
                container.classList.remove('expanded');
                collapsibleContent.style.height = '0px';
            }
        });
    }
};